export const ipData = {
  apiKey: process.env.IPDATA_API_KEY || "132dd9db0a61d635eb72568165ee146caa655dbfe1c02c36dbe06676"
};
